import { render, staticRenderFns } from "./user-head-btn.vue?vue&type=template&id=0fe73ada&scoped=true"
import script from "./user-head-btn.vue?vue&type=script&lang=js"
export * from "./user-head-btn.vue?vue&type=script&lang=js"
import style0 from "./user-head-btn.vue?vue&type=style&index=0&id=0fe73ada&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe73ada",
  null
  
)

export default component.exports